import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'app-hero-title',
    templateUrl: './hero-title.component.html',
    styleUrls: ['./hero-title.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroTitleComponent implements OnInit {
    @Input() title: string;

    constructor() {}

    ngOnInit(): void {}
}
